import { render } from "./PayComponent.vue?vue&type=template&id=6c503866&scoped=true"
import script from "./PayComponent.vue?vue&type=script&lang=js"
export * from "./PayComponent.vue?vue&type=script&lang=js"

import "./PayComponent.vue?vue&type=style&index=0&id=6c503866&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c503866"]])

export default __exports__